import {useQuery} from "@tanstack/react-query"
import {useCallback, useMemo} from "react"
import {outcomeService} from "services"
import {Settings} from "types/settings"

const INITIAL_DATA: Settings.WorkflowTriggerOutcomeItem[] = []

export const useWorkflowTriggerOutcomeItems = () => {
    const {
        data: workflowTriggerOutcomeItems = INITIAL_DATA,
        isLoading,
        isSuccess
    } = useQuery({
        queryKey: ["workflowTriggerOutcomeItems"],
        queryFn: () => outcomeService.getWorkflowTriggerOutcomeItems({filter: {isActive: true}}),
        staleTime: 30 * 60 * 1000
    })

    const workflowTriggerOutcomeIds = useMemo(() => {
        return new Set(
            workflowTriggerOutcomeItems
                .filter(
                    (item: Settings.WorkflowTriggerOutcomeItem) =>
                        item.workflows?.some((workflow) => workflow.isActive) || item.automatedWorkflowId !== null
                )
                .map((item) => item.outcomeId)
        )
    }, [workflowTriggerOutcomeItems])

    const hasWorkflowTrigger = useCallback(
        (outcomeId?: number | null) => {
            if (!outcomeId) return false
            if (!isSuccess) return true
            return workflowTriggerOutcomeIds.has(outcomeId)
        },
        [workflowTriggerOutcomeIds, isSuccess]
    )

    const getWorkflowTriggerItem = useCallback(
        (outcomeId?: number | null) => {
            if (!outcomeId) return undefined
            return workflowTriggerOutcomeItems.find((item) => item.outcomeId === outcomeId)
        },
        [workflowTriggerOutcomeItems]
    )

    return {
        workflowTriggerOutcomeItems,
        hasWorkflowTrigger,
        getWorkflowTriggerItem,
        isLoading
    }
}
